import StatisticCalculator from './statistic_calculator.mjs';
import { get_colorbrewer_scheme } from '../constants/colors.mjs';
import { convertHexToRGBA } from '../helpers/colors.mjs';
import { numberFormatNoDigit } from '../helpers/numbers.mjs';

export default class StatisticCalculatorRevenu extends StatisticCalculator {
  constructor(options = {}) {
    super();
    this.options_ = options;
    this.color_scheme = this.options_?.color_scheme ?? 'Population';
    this.color_buckets = get_colorbrewer_scheme(this.color_scheme, 3);
  }

  refreshStats(stats, fields) {
    this.fields = fields;
    const t_zones = [
      {
        id: 0,
        label: 'Primaire',
        stats: stats.zone_primaire,
      },
      {
        id: 1,
        label: 'Secondaire',
        stats: stats.zone_secondaire,
      },
      {
        id: 2,
        label: 'Teriaire',
        stats: stats.zone_tertiaire,
      },
    ];
    this.indices = {
      france: stats.france,
      zone_global: {},
      zones: [
        {
          id: 0,
          label: 'Primaire',
          indices: {},
        },
        {
          id: 1,
          label: 'Secondaire',
          indices: {},
        },
        {
          id: 2,
          label: 'Tertiaire',
          indices: {},
        },
      ],
    };
    fields.forEach((f) => {
      this.indices.zone_global[f.field] = (stats.zone_global[f.field] / stats.france[f.field]) * 100 - 100;
      this.indices.zones.forEach((z) => {
        let z_indices = z.indices;
        let zone = t_zones[z.id];
        if (zone.stats[f.field]) {
          z_indices[f.field] = (zone.stats[f.field] / stats.france[f.field]) * 100 - 100;
        }
        /*
        else {
          z_indices[f.field] = 100;
        }
        */
      });
    });
    this.stats = {
      zone_global: stats.zone_global,
      zones: t_zones,
    };
    /*
    this.percent_stats = {
      zone_global: this.fields.reduce((acc, curr) => {
        acc[curr.field] = (stats.zone_global[curr.field] / stats.zone_global.p_pop) * 100;
        return acc;
      }, {}),
      zones: [
        {
          id: 0,
          label: 'Primaire',
          stats: this.fields.reduce((acc, curr) => {
            acc[curr.field] = (stats.zone_primaire[curr.field] / stats.zone_global.p_pop) * 100;
            return acc;
          }, {}),
        },
        {
          id: 1,
          label: 'Primaire',
          stats: this.fields.reduce((acc, curr) => {
            acc[curr.field] = (stats.zone_secondaire[curr.field] / stats.zone_global.p_pop) * 100;
            return acc;
          }, {}),
        },
        {
          id: 2,
          label: 'Tertiaire',
          stats: this.fields.reduce((acc, curr) => {
            acc[curr.field] = (stats.zone_tertiaire[curr.field] / stats.zone_global.p_pop) * 100;
            return acc;
          }, {}),
        },
      ],
    };
    */
  }

  getChartDataSet(fields) {
    if (this.base100) {
      return [
        ...this.indices.zones.map((z) => {
          return {
            label: z.label,
            data: fields.map((f) => {
              return z.indices[f.field];
            }),
            backgroundColor: this.color_buckets[z.id],
            /*xAxisID: 'bar-x-axis1',*/
            /*barThickness: 30,*/
            categoryPercentage: 0.8,
            barPercentage: 0.8,
          };
        }),
        ...[
          {
            label: 'Globale',
            data: fields.map((f) => {
              return this.indices.zone_global[f.field];
            }),
            backgroundColor: convertHexToRGBA('#ABABAB', 40),
            xAxisID: 'bar-x-axis2',
            /*barThickness: 100,*/
            categoryPercentage: 1,
            barPercentage: 0.9,
          },
        ],
      ];
    }
    /*
    if (this.as_percent) {
      return [
        ...this.percent_stats.zones.map((z) => {
          return {
            label: z.label,
            data: fields.map((f) => {
              return z.stats[f.field];
            }),
            backgroundColor: this.color_buckets[z.id],
            categoryPercentage: 0.8,
            barPercentage: 0.8,
          };
        }),
        ...[
          {
            label: 'Globale',
            data: fields.map((f) => {
              return this.percent_stats.zone_global[f.field];
            }),
            backgroundColor: convertHexToRGBA('#ABABAB', 40),
            xAxisID: 'bar-x-axis2',
            categoryPercentage: 1,
            barPercentage: 0.9,
          },
        ],
      ];
    }
    */
    return [
      ...this.stats.zones.map((z) => {
        return {
          label: z.label,
          data: fields.map((f) => {
            return z.stats[f.field];
          }),
          backgroundColor: this.color_buckets[z.id],
          /*xAxisID: 'bar-x-axis1',*/
          /*barThickness: 30,*/
          categoryPercentage: 0.8,
          barPercentage: 0.8,
        };
      }),
      ...[
        {
          label: 'Globale',
          data: fields.map((f) => {
            return this.stats.zone_global[f.field];
          }),
          backgroundColor: convertHexToRGBA('#ABABAB', 40),
          xAxisID: 'bar-x-axis2',
          /*barThickness: 100,*/
          categoryPercentage: 1,
          barPercentage: 0.9,
        },
      ],
    ];
  }

  render(containerId = 'charts-content-id', chart_custom_options = {}) {
    let chart_opts = {
      ...{
        legend: {
          position: 'left',
          display: true,
        },
        title: {
          display: true,
          text: 'Répartition de la population',
        },
        base100: false,
        as_percent: false,
        chart_div_id: 'pop_chart',
        chart_canvas_id: 'popchart_id',
      },
      ...chart_custom_options,
    };
    this.base100 = chart_opts.base100;
    this.as_percent = chart_opts.as_percent;
    $(`#${containerId}`)
      .empty()
      .append(
        $(`
          <div id="${chart_opts.chart_div_id}" style="position: relative; height:100%; width:100%;"/>
          </div>`)
      );

    const delta_idx = chart_opts.base100 ? 100 : 0;
    let $pop_chart = $(`#${chart_opts.chart_div_id}`);
    const c_width = parseInt($pop_chart.width());
    const c_height = parseInt($pop_chart.height());
    let $chart_canvas = $(`<canvas id="${chart_opts.chart_canvas_id}" width="${c_width}" height="${c_height}"></canvas>`);
    $pop_chart.append($chart_canvas);
    const t_fields = this.fields.filter((f) => f.field !== 'p_pop');
    const labels = t_fields.map((f) => f.short_label);
    let datasets = this.getChartDataSet(t_fields);
    const post_fixe_label = this.as_percent ? ' %' : '';
    let chart_data = {
      labels,
      datasets,
    };
    let chart_options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: chart_opts.legend,
        title: chart_opts.title,
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || '';
              if (label) {
                label += ': ';
              }

              if (context.parsed.y !== null) {
                label += numberFormatNoDigit(context.parsed.y) + post_fixe_label;
              }

              return label;
            },
          },
        },
      },
      scales: {
        x: {
          type: 'category',
          labels: labels,
          display: false,
        },
        y: {
          ticks: {
            callback: (val) => {
              return `${val + delta_idx}${post_fixe_label}`;
            },
          },
        },
      },
    };
    if (chart_opts.oncomplete_func) {
      chart_options.animation = {
        onComplete: () => {
          chart_opts.oncomplete_func(the_chart, containerId);
        },
      };
    }
    let the_chart = new Chart($chart_canvas, {
      type: 'bar',
      data: chart_data,
      options: chart_options,
    });
    return the_chart;
  }
}
